
import { useContext, useRef, useEffect } from "react";
import {
	Grid2 as Grid,
	Stack,
	Table,
	Dialog,
	TableRow,
	TableHead,
	TableCell,
	TableBody,
	Typography,
	IconButton,
	DialogTitle,
	DialogContent,
	TableContainer,
	Button,
	MenuItem,
	Menu,
} from "@mui/material";
import { useQuery } from "@apollo/client";

//Icons
import { BiMinusCircle } from "react-icons/bi";

//Srcs
import "../../Style/dialogStyle.scss";
import { AuthContext } from "../../Context/AuthContext";
import { translateLauguage } from "../../Function/Translate";
import EmptyData from "../../Components/Include/EmptyData";
import LoadingPage from "../../Components/Include/LoadingPage";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useState } from "react";
import { styled } from "@mui/system";
import html2canvas from "html2canvas";
import DownloadRoundedIcon from '@mui/icons-material/DownloadRounded';
import { useReactToPrint } from "react-to-print";
import PrintIcon from "@mui/icons-material/Print";
import { GET_STUDENT_ATTENDANCE_PERCENTAGE } from "../../Schema/Dashboard"
import {
	SelectSchool,
	SelectLevel,
	// SelectGroup,
	// SelectTeacher,
	SelectAcademicYear,
	SelectTeacherUserByAcademicYear
  } from "../../Function/DynamicSelect";

const StyledMenu = styled((props) => (
	<Menu
		elevation={0}
		anchorOrigin={{
			vertical: "bottom",
			horizontal: "right",
		}}
		transformOrigin={{
			vertical: "top",
			horizontal: "right",
		}}
		{...props}
	/>
))(({ theme }) => ({
	"& .MuiPaper-root": {
		borderRadius: 6,
		marginTop: theme.spacing(1),
		minWidth: 180,
		color: "rgb(55, 65, 81)",
		boxShadow:
			"rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
		"& .MuiMenu-list": {
			padding: "4px 0",
		},
		...theme.applyStyles("dark", {
			color: theme.palette.grey[300],
		}),
	},
}));


export default function AttendancePercentage({ open, handleClose, activeAcademicYearVal }) {

	// ===================== Change Language ========================== 
	const { language, setAlert } = useContext(AuthContext);
	const { t } = translateLauguage(language);

	let userLogin = JSON.parse(window.localStorage.getItem("logIn"));


	const [anchorEl, setAnchorEl] = useState(null);
	const openDownload = Boolean(anchorEl);
	const handleClick = (event) => setAnchorEl(event.currentTarget);
	const handleCloseDownload = () => setAnchorEl(null);

	const [levelVal, setLevelVal] = useState({ id: null, title: "" });
	const [groupVal, setGroupVal] = useState({ id: null, title: "" });
	const [schoolVal, setSchoolVal] = useState({ id: null, title: "" });
	const [teacherVal, setTeacherVal] = useState({ id: null, title: "" });
	const [academicYearVal, setAcademicYearVal] = useState(activeAcademicYearVal);

	const [loading, setLoading] = useState(true)
	const [studentData, setStudentData] = useState([])

	const componentRef = useRef(null);
	const handleDownload = async () => {
		if (!componentRef.current) return;
		const canvas = await html2canvas(componentRef.current);
		const image = canvas.toDataURL("image/png");
		const link = document.createElement("a");
		link.href = image;
		link.download = "Student-Attendance-less-then-80%.png";
		link.click();
	};

	const handlePrint = useReactToPrint({
		content: () => componentRef.current,
		documentTitle: "Student-Attendance-less-then-80%-pdf"
	});

	const { refetch } = useQuery(GET_STUDENT_ATTENDANCE_PERCENTAGE, {
		variables: {
			academicYearId: academicYearVal?.id ?? null,
			schoolId: schoolVal?.id ?? null,
			teacherId: teacherVal?.id ?? null,
			levelId: levelVal?.id ?? null
		},
		onCompleted: ({ getStudentAttendancePercentage }) => {
			setStudentData(getStudentAttendancePercentage);
			setLoading(false);
		},
		onError: (err) => {
			console.log("Error::", err?.message);
		},
	});
	
	useEffect(() => { setLoading(true) }, [academicYearVal?.id, schoolVal?.id, teacherVal?.id, levelVal?.id])
	
	return (
		<Dialog open={open} className="dialog-container" fullWidth maxWidth="lg">
			<DialogTitle sx={{ padding: "10px 15px 10px 20px " }}>
				<Stack direction="row" justifyContent="space-between">
					<Stack direction="column" justifyContent="center">
						<Typography
							className={language === "en" ? "dialog-title" : "dialog-title-kh"}
						>
							{t("dialog_title_view_attendance")}
						</Typography>
					</Stack>
					<Stack direction="column" justifyContent="center">
						<IconButton onClick={handleClose}>
							<BiMinusCircle className="close-icon" />
						</IconButton>
					</Stack>
				</Stack>
			</DialogTitle>

			<DialogContent dividers>

				<Grid container spacing={2}>
					<Grid size={{ xs: 12, sm: 6, md: 6, lg: 4, xl: 2 }}>
						<Typography
							className={
								language === "kh" ? "header-text-kh" : "header-text"
							}
						>
							{t(`academic_year`)}
						</Typography>
						<SelectAcademicYear
							selectedVal={academicYearVal}
							setSelectedVal={setAcademicYearVal}
							className="search-field"
							setLoading={setLoading}
						/>
					</Grid>
					<Grid size={{ xs: 12, sm: 6, md: 6, lg: 4, xl: 2 }}>
						<Typography
							className={
								language === "kh" ? "header-text-kh" : "header-text"
							}
						>
							{t(`school`)}
						</Typography>
						<SelectSchool
							selectedVal={schoolVal}
							setSelectedVal={setSchoolVal}
							className="search-field"
							// disabled={academicYearVal?.id ? false : true}
							disabled={!academicYearVal?.id || userLogin?.role === "Teacher"}
							setLoading={setLoading}
						/>
					</Grid>

					<Grid size={{ xs: 12, sm: 6, md: 6, lg: 4, xl: 2 }}>
						<Typography
							className={
								language === "kh" ? "header-text-kh" : "header-text"
							}
						>
							{t(`grade_level`)}
						</Typography>
						<SelectLevel
							selectedVal={levelVal}
							setSelectedVal={setLevelVal}
							className="search-field"
							// disabled={academicYearVal?.id && schoolVal?.id ? false : true}
							setLoading={setLoading}
							disabled={!academicYearVal?.id && !schoolVal?.id || userLogin?.role === "Teacher"}
						/>
					</Grid>
					<Grid size={{ xs: 12, sm: 6, md: 6, lg: 4, xl: 2 }}>
						<Typography
							className={
								language === "kh" ? "header-text-kh" : "header-text"
							}
						>
							{t(`teacher`)}
						</Typography>
						<SelectTeacherUserByAcademicYear
							selectedVal={teacherVal}
							setSelectedVal={setTeacherVal}
							className="search-field"
							academicYearId={academicYearVal?.id}
							schoolId={schoolVal?.id}
							setLoading={setLoading}
							disabled={userLogin?.role === "Teacher" ? true : false}
						/>
					</Grid>
					<Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
						<Stack direction="row" justifyContent="right">
							<Button
								id="demo-customized-button"
								aria-controls={open ? "demo-customized-menu" : undefined}
								aria-haspopup="true"
								aria-expanded={open ? "true" : undefined}
								variant="contained"
								disableElevation
								onClick={handleClick}
								className="btn-create-style"
								endIcon={<KeyboardArrowDownIcon />}
							>
								{t("btn-download")}
							</Button>
						</Stack>
						<StyledMenu
							id="demo-customized-menu"
							MenuListProps={{
								"aria-labelledby": "demo-customized-button",
							}}
							anchorEl={anchorEl}
							open={openDownload}
							onClose={handleCloseDownload}
						>

							<MenuItem
								onClick={() => {
									handleDownload();
									handleCloseDownload();
								}}
								disableRipple
								className="student-menu-item"
							>
								<Stack
									direction="row"
									spacing={1}
									alignItems="center"
									justifyContent="center"
								>
									<DownloadRoundedIcon className="icon" />
									<Typography
										className={language === "en" ? "action-txt" : "action-txt-kh"}
									>
										{t("img")}
									</Typography>
								</Stack>
							</MenuItem>
							<MenuItem
								onClick={() => {
									handlePrint();
									handleCloseDownload();
								}}
								disableRipple
								className="student-menu-item"
							>
								<Stack
									direction="row"
									spacing={1}
									alignItems="center"
									justifyContent="center"
								>
									<PrintIcon className="icon" />
									<Typography
										className={language === "en" ? "action-txt" : "action-txt-kh"}
									>
										{t("pdf")}
									</Typography>
								</Stack>
							</MenuItem>
						</StyledMenu>
					</Grid>

				</Grid>
				<TableContainer className="adjust-container" ref={componentRef}>
					<Table className="table" aria-label="simple table">
						{/* <TableHead className="header-row "> */}

						<TableRow className="header-row ">
							<TableCell className={language === "en" ? "header-title-start" : "header-title-start-kh"}>
								{t("thead_student_id")}
							</TableCell>

							<TableCell className={language === "en" ? "header-title" : "header-title-kh"}>
								{t("thead_student_name")}
							</TableCell>

							<TableCell className={language === "en" ? "header-title" : "header-title-kh"}>
								{t("thead_latin_name")}
							</TableCell>

							<TableCell className={language === "en" ? "header-title" : "header-title-kh"}>
								{t("thead_gender")}
							</TableCell>

							<TableCell className={language === "en" ? "header-title" : "header-title-kh"}>
								{t("school")}
							</TableCell>

							<TableCell className={language === "en" ? "header-title" : "header-title-kh"} align="center">
								{t("grade_level")}
							</TableCell>

							<TableCell className={language === "en" ? "header-title" : "header-title-kh"} align="center">
								{t("group")}
							</TableCell>

							<TableCell className={language === "en" ? "header-title" : "header-title-kh"} align="center">
								{t("percentage")}
							</TableCell>

							<TableCell className={language === "en" ? "header-title-end" : "header-title-end-kh"} ></TableCell>

						</TableRow>

						{/* </TableHead> */}

						{loading ? (
							<TableBody className="table-body">
								<TableRow className="body-row">
									<TableCell colSpan={10} className="body-cell">
										<LoadingPage />
									</TableCell>
								</TableRow>
							</TableBody>
						) : (
							<>
								{studentData?.length === 0 ? (
									<TableBody className="table-body">
										<TableRow className="body-row">
											<TableCell colSpan={10} className="body-cell">
												<EmptyData />
											</TableCell>
										</TableRow>
									</TableBody>
								) : (
									<>
										<TableBody className="table-body">
											{studentData?.map((row, index) => {
											
												return (
													<TableRow className="body-row" key={index}>
														<TableCell className={language === "en" ? "body-cell-start" : "body-cell-start-kh"} >
															{row?.student_id}
														</TableCell>

														<TableCell className={"body-cell-kh"}>
															{row?.full_name_kh}
														</TableCell>

														<TableCell className={language === "en" ? "body-cell" : "body-cell-kh"}>
															{row?.full_name_latin}
														</TableCell>

														<TableCell className={language === "en" ? "body-cell" : "body-cell-kh"}>
															{row?.gender}
														</TableCell>

														<TableCell className={language === "en" ? "body-cell" : "body-cell-kh"}>
															{language === "en" ? row?.school_name_en : row?.school_name_kh}
														</TableCell>

														<TableCell className={language === "en" ? "body-cell" : "body-cell-kh"} align="center" >
															{row?.level}
														</TableCell>

														<TableCell className={language === "en" ? "body-cell" : "body-cell-kh"} align="center" >
															{row?.group}
														</TableCell>

														<TableCell className={language === "en" ? "body-cell" : "body-cell-kh"} align="center" >
															{(row?.attendancePercentage)?.toFixed(0)} %
														</TableCell>

														<TableCell
															className={
																language === "en"
																	? "body-cell-end"
																	: "body-cell-end-kh"
															}
															align="right"
														>

														</TableCell>
													</TableRow>
												);
											})}
										</TableBody>
									</>
								)}
							</>
						)}
					</Table>
				</TableContainer>

			</DialogContent>

		</Dialog>
	)
}
